import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_409pab9jko: FaireBrandEntity = {
  token: "b_409pab9jko",
  type: "brand",
  name: "Belong Designs",
  avatarUrl:
    "https://cdn.faire.com/fastly/4322c382346173610bb171f86449d71ca9cffc84dfd4ef851f29dcc3a2d16f76.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8fde6a3d3468f93296dff40577c762ac196d456cf7606fb4b79f6799f5ec7e92.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4322c382346173610bb171f86449d71ca9cffc84dfd4ef851f29dcc3a2d16f76.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8fde6a3d3468f93296dff40577c762ac196d456cf7606fb4b79f6799f5ec7e92.jpeg",
  location: "Denver, CO, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 39,
  isTopShop: true,
  isInsider: true,
  description:
    "Belong Designs was born out of the Rocky Mountains where the driving force and passion of the brand has always been the same: to support and inspire people to follow their passions, do what they love, and find where they Belong. The company was started in 2013, and since then the idea of Belonging has been an all-encompassing idea and mission. We're not destination focused - we're dedicated to enjoying the journey.\n\nEvery day we strive to make every part of our process - our designs, our fabrics, and our clothing - just a little bit better so that they can continue to elevate experiences in all parts of life. This year, and in the years to come, you'll notice many of our blends and fabrics will continue to evolve. We'll continue investing our time and resources into furthering the sustainability of the apparel and packaging that we make. We hope to further our sustainability and continue to reduce our impact, with a goal of being carbon neutral by 2030. \n\nYou are an extension of our brand and our mission.  We are very much humbled and grateful for your support, and we're excited to grow this brand and mission with you.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:37.898Z",
    importedBy: "entity-db-cli",
  },
};
